var exports = {
  "v": "LinkedPullRequestToken__r2SMqy",
};

module.exports = exports;
